// extracted by mini-css-extract-plugin
module.exports = {"folderGrid":"ProjectGrid_folderGrid__3ayPh","folderImage":"ProjectGrid_folderImage__2GoT4","item":"ProjectGrid_item__2spXK"};